<template>
  <div>
    <m-modal-setting ref="modalSetting"></m-modal-setting>
    <m-modal-pricing></m-modal-pricing>
    <m-modal-digital-campaigns />

    <m-contact-us/>
  <b-navbar toggleable="md" class="navbar header-top-scrool">
    <b-container fluid class="m-layout-content">
      <b-navbar-brand href="#" v-if="this.$store.state.site.User_RoleName === 'Digital User'">
        <b-link :to="{name: 'DigitalReporting'}">
          <img src = "../../assets/images/Logo_SL360_new.png" class="img-logo">
        </b-link>
      </b-navbar-brand>
      <b-navbar-brand href="#" v-else>
        <b-link :to="{name: 'landing'}">
          <img src = "../../assets/images/Logo_SL360_new.png" class="img-logo">
        </b-link>
      </b-navbar-brand>

      <b-nav-toggle target="nav_collapse" postion="left" right></b-nav-toggle>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="ml-auto">
          <a class="nav-link nav-link-top" :href ="$store.getters['config/link']('history')"
                                           v-m-ua-event="['header', 'user', 'order history']">
            Order History</a>
          <!--<b-nav-item-dropdown text="History" right :hidden="!showHistoryMenu">-->
            <!--<b-link class="nav-link"-->
                    <!--:href ="$store.getters['config/link']('history')"-->
                    <!--data-test="OrderHistory"-->
                    <!--v-m-ua-event="['header', 'user', 'order history']">-->
              <!--<icon name="file-text-o" class="nav-icon"/>-->
              <!--Order History-->
            <!--</b-link>-->
            <!--<b-link class="nav-link"-->
                    <!--@click="gotoDigitalReporting"-->
                    <!--data-test="DigitalHistory">-->
              <!--<icon name="file-text-o" class="nav-icon"/>-->
              <!--Digital History-->
            <!--</b-link>-->
          <!--</b-nav-item-dropdown>-->
          <!--<a class="nav-link nav-link-top"  :href ="$store.getters['config/link']('history')"-->
                                             <!--v-m-ua-event="['header', 'user', 'order history']" :hidden="!showOrderHistoryMenu">-->
            <!--Order History</a>-->
          <!--<a class="nav-link nav-link-top"  data-test="DigitalHistory" @click="gotoDigitalReporting" :hidden="!showDigitalHistoryMenu">-->
            <!--Digital History</a>-->
          <a class="nav-link nav-link-top" :href="$store.getters['config/link']('mysavecount')"
            v-m-ua-event="['header', 'user', 'SLC']" :hidden="this.$store.state.site.User_RoleName === 'Digital User'">
            Saved List Counts</a>
          <a class="nav-link nav-link-top" @click="$root.$emit('openNav', 'reach')" :hidden="this.$store.state.site.User_RoleName === 'Digital User'">Choose Audience</a>

          <a class="nav-link nav-link-top" @click="$root.$emit('openNav', 'manage')" v-if="(userServiceDataSources.showEnhanceList||userServiceDataSources.showEmailAppend||userServiceDataSources.showPhoneAppend||userServiceDataSources.showPhoneReverse||userServiceDataSources.showEmailReverse||userServiceDataSources.showCleanList||userServiceDataSources.showEmailVerification||userServiceDataSources.showPhoneVerification)">Manage Customer Data</a>

          <a class="nav-link nav-link-top" @click="$root.$emit('openNav', 'analyze')" v-if="userServiceDataSources.showPortraitReports">Analyze Customers</a>

          <a class="nav-link nav-link-top"  @click="$root.$emit('openNav', 'contact')">Contact Us</a>

          <a class="nav-link nav-link-top" data-test="headUserName" @click="$root.$emit('openNav', 'user-name')">
            <img :src="userimg" class="user">
            {{username}}</a>
        </b-navbar-nav>
      </b-collapse>
      <m-nav code = "reach">
          <div class="the-nav-box" data-test="mailing-list">
            <div class="nav-block">
              <p class="nav-title">Choose Your Audience</p>
              <p class="nav-brief">Build, order and download in just minutes! Start by selecting the type of prospects you want to contact:</p>
              <b-link class="nav-link"
                      v-for="(item,index) in topBtns"
                      :key="item.ListType"
                      @click="go(item.ListType)"
                      :data-test="'head1'+ index"
                      v-m-ua-event="['header', 'datasource', item.Desc]">
                <icon :name="item.icon" class="nav-icon"/>
                {{item.Desc}}</b-link>
              <b-link class="nav-link"
                      v-for="(item,index) in normalBtns"
                      :key="item.ListType"
                      :data-test="'head1'+ (index + 2)"
                      @click="go(item.ListType)"
                      v-m-ua-event="['header', 'datasource', item.Desc]">
                <icon :name="item.icon" class="nav-icon"/>
                {{item.Desc}}</b-link>

            </div>
            <div class="nav-block">
              <p class="nav-title">Begin a Digital Campaign</p>
              <p class="nav-brief">Tell us your goals and budget. Our experts will craft and manage a full-service campaign.</p>
              <b-link class="nav-link"
                      @click="goPage(() =>{$root.$emit('bv::show::modal', 'modelDigitalCampaigns')})"
                      v-m-ua-event="['header', 'datasource', 'Email Marketing']"
                      data-test="head20">
                <icon name="at" class="nav-icon"/>
                Email Marketing</b-link>
              <b-link class="nav-link"
                      @click="goPage(() =>{$root.$emit('bv::show::modal', 'modelDigitalCampaigns')})"
                      v-m-ua-event="['header', 'datasource', 'Display & Social Medial']"
                      data-test="head21">
                <icon name="television" class="nav-icon"/>
                Display & Social Media</b-link>
              <b-link class="nav-link"
                      @click="goPage(() =>{$root.$emit('bv::show::modal', 'modelDigitalCampaigns')})"
                      v-m-ua-event="['header', 'datasource', 'Multi-channel Marketing']"
                      data-test="head22">
                <icon name="share-alt" class="nav-icon"/>
                Multi-Channel Marketing</b-link>
            </div>
            <!--<div class="nav-block">-->
              <!--<p class="nav-title">Get Expert Advice</p>-->
              <!--<p class="nav-brief">Not sure what you need, or where to start? We're eager to help you make the most of your campaign.</p>-->
              <!--<b-btn @click="showContactUs">Start a Chat</b-btn>-->
            <!--</div>-->
          </div>
      </m-nav>
      <m-nav code="manage">
          <div class="the-nav-box">
            <div class="nav-block">
              <p class="nav-title">Enhance Your Data</p>
              <p class="nav-brief">Append data to your customer database so you may increase its segmentation capabilities, expand your communication reach, and more effectively communicate.</p>
              <b-link class="nav-link"
                      v-for="(menu,index) in menus"
                      v-if="menu.type === 'enhance' && menu.show"
                      :key="menu.title"
                      :data-test="'headenhance'+index"
                      :href="$store.getters['config/link'](menu.link)"
                      v-m-ua-event="['header', 'dataservice', menu.title]"
              >
                <icon :name="menu.icon" class="nav-icon"/>
                {{menu.title}}</b-link>
            </div>
            <div class="nav-block">
              <p class="nav-title">Clean & Verify Your Data</p>
              <p class="nav-brief">De-duplicate records, correct undeliverable addresses and screen for privacy... all to save time and money.</p>
              <b-link class="nav-link"
                      v-for="(menu,index) in menus"
                      v-if="menu.type === 'clean' && menu.show"
                      :key="menu.title"
                      :data-test="'headeclean'+index"
                      :href="$store.getters['config/link'](menu.link)"
                      v-m-ua-event="['header', 'dataservice', menu.title]"
              >
                <icon :name="menu.icon" class="nav-icon"/>
                {{menu.title}}</b-link>
            </div>
          </div>
      </m-nav>

      <m-nav code="analyze">
        <div class="the-nav-box">
          <div class="nav-block">
            <p class="nav-title">Analyze My Customers
            </p>
            <p class="nav-brief">Order a report to gain insight into the demographic and psychographic characteristics of your customers so you may more effectively choose new prospects who are more likely to become customers.
            </p>
            <b-link class="nav-link"
                    :href="$store.getters['config/link']('portaitreports')"
                    data-test="customerPortraitReports"
                    v-m-ua-event="['header', 'dataservice', 'Analyze your customers']">
              <icon name="file-text-o" class="nav-icon"/>
              Customer Portrait Reports
            </b-link>
            <!--<b-link class="nav-link"-->
                    <!--@click="gotoDigitalReporting"-->
                    <!--data-test="DigitalReporting"-->
                    <!--&gt;-->
              <!--<icon name="file-text-o" class="nav-icon"/>-->
              <!--DigitalReporting-->
            <!--</b-link>-->
          </div>
          <div class="nav-block">
            <p class="nav-title">View Sample Reports</p>
            <b-link class="nav-link" data-test="viewSampleReports1" :href="$store.getters['config/link']('reportLookALike')" target="_blank"> <icon name="file-text-o" class="nav-icon"/>Preview a Look-Alike Report</b-link>
            <b-link class="nav-link" data-test="viewSampleReports2" :href="$store.getters['config/link']('reportEnhanceLookAlike')" target="_blank"> <icon name="file-text-o" class="nav-icon"/>Preview an Enhanced Look-Alike Report</b-link>
            <b-link class="nav-link" data-test="viewSampleReports3" :href="$store.getters['config/link']('reportPortrait')" target="_blank"> <icon name="file-text-o" class="nav-icon"/>Preview a PersonicX Portrait Report</b-link>
            <b-link class="nav-link" data-test="viewSampleReports4" :href="$store.getters['config/link']('reportPortraitRegional')" target="_blank"> <icon name="file-text-o" class="nav-icon"/>Preview a Data Portrait Analysis</b-link>
          </div>
          <!--<div class="nav-block">-->
            <!--<p class="nav-title">Get Expert Advice</p>-->
            <!--<p class="nav-brief">Not sure what you need, or where to start? We're eager to help you make the most of your campaign.</p>-->
            <!--<b-btn @click="showContactUs">Start a Chat</b-btn>-->
          <!--</div>-->
        </div>
      </m-nav>

      <m-nav code="contact">
        <div class="the-nav-box">
          <div class="nav-block">
            <p class="nav-title">Contact Us
            </p>
            <p class="nav-brief">We're available Monday through Friday, 9am to 5pm Eastern Time.
            </p>
            <b-link  @click="showContactUs"
                     class="nav-link"
                     data-test="contactus"
                     v-m-ua-event="['header', 'contactUs', 'message']">
              <icon name="comments-o" class="nav-icon" />
              Contact Us
            </b-link>
            <b-link href="tel://800-399-8611"
                    class="nav-link"
                    data-test="tel"
                    v-m-ua-event="['header', 'contactUs', 'phone']">
              <icon name="phone" class="nav-icon" />
              800-399-8611
            </b-link>
            <b-link  href="mailto:support@sl360.com"
                     class="nav-link"
                     data-test="email"
                     v-m-ua-event="['header', 'contactUs', 'email']">
              <icon name="envelope-o" class="nav-icon" />
              support@sl360.com
            </b-link>
            <b-link :href="$store.state.config.link.twitter"
                    class="nav-link"
                    data-test="twitter"
                    v-m-ua-event="['header', 'contactUs', 'twitter']">
              <icon name="twitter" class="twitter-icon nav-icon" />
              Follow @SL360.com
            </b-link>
          </div>
          <div class="nav-block" style="max-width: 66%">
            <p class="nav-title">Jot Us a Note</p>
            <b-row>
              <b-col>
                <b-form-textarea :rows="5"  :state="this.infoValid.message.state" placeholder="Message *" v-model="info.message"></b-form-textarea>
                <span v-if="infoValid.message.text" class="text-danger">{{infoValid.message.text}}</span>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col sm="5">
                <b-form-input placeholder="Name *" :state="this.infoValid.name.state" v-model="info.name"></b-form-input>
                <span v-if="infoValid.name.text" class="text-danger">{{infoValid.name.text}}</span>
              </b-col>
              <b-col sm="5">
                <b-form-input placeholder="Email address *" :state="this.infoValid.email.state" type="email" v-model="info.email"></b-form-input>
                <span v-if="infoValid.email.text" class="text-danger">{{infoValid.email.text}}</span>
              </b-col>
              <b-col sm="2">
                <b-btn :disabled="btnDisable" @click="submit">Send</b-btn>
              </b-col>
            </b-row>
          </div>
        </div>
      </m-nav>

      <m-nav code="user-name">
        <div class="the-nav-box">
          <div class="nav-block" :hidden="this.$store.state.site.User_RoleName === 'Digital User'">
            <p class="nav-title">Review Account History
            </p>
            <p class="nav-breif">Download a list from a past order. Pick up where you left off with a saved count. Redeem or check on rewards.</p>
            <!--<p class="nav-brief">My Account-->
            <!--</p>-->
            <b-link class="nav-link"
                    data-test="headOrderHistory"
                    :href ="$store.getters['config/link']('history')"
                    v-m-ua-event="['header', 'user', 'order history']">
              <icon name="history" class="nav-icon" />
              Order History
            </b-link>
            <b-link class="nav-link"
                    data-test="headSavedListCounts"
                    :href="$store.getters['config/link']('mysavecount')"
                    v-m-ua-event="['header', 'user', 'SLC']">
              <icon name="save" class="nav-icon" />
              Saved List Counts
            </b-link>
            <b-link class="nav-link"
                    data-test="headRewards"
                    @click="goPage(() =>{$router.push({name: 'reward'})})"
                    v-m-ua-event="['header', 'user', 'reward']">
              <icon name="gift" class="nav-icon" />
              Rewards
            </b-link>
          </div>
          <div class="nav-block">
            <p class="nav-title">Manage Your Account</p>
            <p class="nav-breif">Access your rate sheet for lists and services. Adjust your account preferences and settings, or exit SL360.</p>
            <b-link class="nav-link" v-b-modal.modalPricing
                    data-test="headPricing"
                    @click="goPage"
                    v-m-ua-event="['header', 'user', 'pricing']" :hidden="this.$store.state.site.User_RoleName === 'Digital User'">
              <icon name="dollar" class="nav-icon" style="margin-right: 8px"/>Pricing
            </b-link>

            <b-link class="nav-link" v-b-modal.modelSetting
                    data-test="headSetting"
                    @click="goPage"
                    id="sheadernavuser"
                    v-m-ua-event="['header', 'user', 'setting']">
              <icon name="user-o" class="nav-icon" />Settings
            </b-link>
            <b-link class="nav-link" @click="logOut"
                    data-test="headLogOut"
                    v-m-ua-event="['header', 'user', 'logout']">
              <icon name="sign-out" class="nav-icon" />Log out
            </b-link>
          </div>
          <!--<div class="nav-block">-->
            <!--<p class="nav-title">Get Expert Advice</p>-->
            <!--<p class="nav-brief">Not sure what you need, or where to start? We're eager to help you make the most of your campaign.</p>-->
            <!--<b-btn @click="showContactUs">Start a Chat</b-btn>-->
          <!--</div>-->
        </div>
      </m-nav>
    </b-container >
  </b-navbar>
  </div>
</template>
<script>
  import MModalPricing from '@/components/landings/MModalPricing'
  import MModalSetting from '@/components/landings/MModalSetting'
  import jsCookie from 'js-cookie'
  import MContactUs from '@/components/landings/MContactUs'
  import MModalDigitalCampaigns from '@/components/landings/MModalDigitalCampaigns'
  import MNav from '@/components/layouts/MNav'
  import notificaton from '@/components/common/notification'

  export default {
    components: {
      MModalPricing,
      MModalSetting,
      MContactUs,
      MModalDigitalCampaigns,
      MNav
    },
    computed: {
      username () {
        return this.$store.state.site.User_FullName || 'welcome'
      },
      userimg () {
        return this.$store.state.site.UserImg
      },
      userDataSources () {
        return this.$store.state.user.userDataSources
      },
      userServiceDataSources () {
        return this.$store.state.user.userServiceDataSources
      },
      topBtns () {
        var result = []
        for (var i = 0; i < this.userDataSources.length; i++) {
          var item = this.userDataSources[i]
          if (item.ListType === 10 || item.ListType === 170) {
            result.push(item)
          }
        }
        return result
      },
      normalBtns () {
        var result = []
        for (var i = 0; i < this.userDataSources.length; i++) {
          var item = this.userDataSources[i]
          if (item.ListType !== 10 && item.ListType !== 170) {
            result.push(item)
          }
        }
        return result
      },
      menus () {
        var result = [
          {
            title: 'Append Demographics or Psychographics',
            benefit: 'Gives your customer database more segmentation capabilities and helps you better communicate with customers around their interests and life stage.',
            link: 'enhanceList',
            icon: 'share-alt',
            type: 'enhance',
            show: this.userServiceDataSources.showEnhanceList
          }, {
            title: 'Clean your Database',
            benefit: 'Save money avoiding duplicate and undeliverable mail, and marketing to only those qualified for your product or service.',
            link: 'cleanList',
            icon: 'eraser',
            type: 'clean',
            show: this.userServiceDataSources.showCleanList
          }, {
            title: 'Append Email Addresses',
            benefit: 'Adding email addresses to your database helps you communicate with customers through a new and low-cost channel.',
            link: 'emailAppend',
            icon: 'envelope-open-o',
            type: 'enhance',
            show: this.userServiceDataSources.showEmailAppend
          }, {
            title: 'Verify Email Addresses',
            benefit: 'Reduces undeliverable email which helps keep your sender reputation strong so ESPs continue delivering your email.',
            link: 'emailVerification',
            icon: 'envelope-o',
            type: 'clean',
            show: this.userServiceDataSources.showEmailVerification
          }, {
            title: 'Append Phone Numbers',
            benefit: 'Provides an additional and low cost channel to communicate with customers.',
            link: 'phoneAppend',
            icon: 'phone',
            type: 'enhance',
            show: this.userServiceDataSources.showPhoneAppend
          }, {
            title: 'Reverse Phone Append',
            benefit: 'Helps reveal who contacted you and enables you to reach them via direct mail.',
            link: 'phoneReverse',
            icon: 'phone',
            type: 'enhance',
            show: this.userServiceDataSources.showPhoneReverse
          }, {
            title: 'Reverse Email Append',
            benefit: 'Helps reveal who contacted you and enables you to reach them via direct mail.',
            link: 'reverseEmailAppend',
            icon: 'envelope-open-o',
            type: 'enhance',
            show: this.userServiceDataSources.showEmailReverse
          }, {
            title: 'Phone Confirmation & Append',
            benefit: 'Saves you time calling bad numbers and improves your connection rate with customers.',
            link: 'phoneVerification',
            icon: 'volume-control-phone',
            type: 'clean',
            show: this.userServiceDataSources.showPhoneVerification
          }
        ]
        return result
      },
      showHistoryMenu () {
        if (this.$store.state.user.ShowDigitalHistory && this.$store.state.user.ShowOrderHistory) {
          return true
        } else {
          return false
        }
      },
      showOrderHistoryMenu () {
        if (!this.$store.state.user.ShowDigitalHistory && this.$store.state.user.ShowOrderHistory) {
          return true
        } else {
          return false
        }
      },
      showDigitalHistoryMenu () {
        if (this.$store.state.user.ShowDigitalHistory && !this.$store.state.user.ShowOrderHistory) {
          return true
        } else {
          return false
        }
      }
    },
    data () {
      return {
        info: {
          name: '',
          email: '',
          message: ''
        },
        btnDisable: false,
        infoValid: {
          name: {
            state: null,
            text: ''
          },
          email: {
            state: null,
            text: ''
          },
          message: {
            state: null,
            text: ''
          }
        },
        isShowSuccess: false
      }
    },
    methods: {
      go (listType) {
        this.$router.push({
          name: 'order',
          params: {
            listType: listType
          }
        })
        this.$root.$emit('closeAllNav')
      },
      goPage (cb) {
        if (typeof cb === 'function') {
          cb()
        }
        this.$root.$emit('closeAllNav')
      },
      gotoDigitalReporting () {
        this.$router.push({
          name: 'DigitalReporting'
        })
      },
      showContactUs () {
        this.$root.$emit('bv::show::modal', 'modalContactUs')
        this.$root.$emit('closeAllNav')
      },
      showContactUsFreeDiagnostic () {
        this.$root.$emit('bv::show::modal', 'modalContactUsFreeDiagnostic')
        this.$root.$emit('closeAllNav')
      },
      logOut () {
        window.location = this.$store.getters['config/link']('logOut')
        jsCookie.remove('denglu')
      },
      submit () {
        this.clearValid(this.infoValid)
        let that = this
        if (this.validInfo()) {
          this.btnDisable = true
          this.$http.post(this.$store.getters['config/link']('sendMessage'), {
            Action: 'save-contact-info',
            FormData: JSON.stringify({
              FirstName: this.info.name,
              LastName: '',
              Company: '',
              Email: this.info.email,
              Phone: '',
              Comment: this.info.message,
              Page: 'SL360',
              PageInfo: 'SL360',
              FromSite: 'SL360',
              Source: '',
              fromsite: 'SL360'
            })
          }, {
            emulateJSON: true
          }).then(resp => {
            that.btnDisable = false
            if (resp.body.Status === 1) {
              notificaton.notice('success', 'Message successfully sent')
              this.$root.$emit('closeAllNav')
            } else {
              notificaton.notice('error', 'Message failed to be sent')
            }
          }, resp => {
            this.btnDisable = false
          })
        }
      },
      validInfo () {
        let isValid = true
        if (!this.info.name) {
          this.infoValid.name.state = false
          this.infoValid.name.text = "It's required"
          isValid = false
        }
        if (!(this.info.email.indexOf('@') > 0 && this.info.email.indexOf('@') < this.info.email.length - 1)) {
          this.infoValid.email.state = false
          this.infoValid.email.text = 'E-mail must be valid'
          isValid = false
        }
        if (!this.info.email) {
          this.infoValid.email.state = false
          this.infoValid.email.text = "It's required"
          isValid = false
        }
        if (!this.info.message) {
          this.infoValid.message.state = false
          this.infoValid.message.text = "It's required"
          isValid = false
        }
        return isValid
      },
      clearValid (items) {
        for (let key in items) {
          items[key].state = null
          items[key].text = false
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .img-logo {
    height: 51px;
    width: auto;
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .navbar{
    background: $color-white;
    border-bottom: 1px solid #ccc;
    box-shadow: 0 2px 4px -1px rgba(0,0,0,.1), 0 4px 5px 0 rgba(0,0,0,.04), 0 1px 10px 0 rgba(0,0,0,.02);
  }
  .user {
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    object-fit: cover;
    vertical-align: middle;
    margin-right: 10px;
  }
  .ml-auto {
    display: flex;
    align-items: center;
  }
  .nav-item {
    font-size: 16px;
  }
  .user-name {
    font-weight: bold;
  }
  .twitter-icon {
    color: $color-primary;
  }
  .the-nav-box {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }

  .nav-block {
    flex-grow: 1;
    max-width: 30%;
  }

  @media(max-width: 768px) {
    .the-nav-box {
      flex-direction: column;
    }
    .nav-block {
      max-width: 100% !important;
      width: 100%;
    }

  }

  .nav-brief {
    color: #333;
  }

  .nav-title {
    margin-bottom: 0;
    color: $color-primary;
    font-size: 16px;
  }
  .nav-icon {
    margin-right: 8px;
    width: 16px;
  }

  .nav-link {
    color:  $color-text-grey !important;
    text-decoration: none !important;
  }
  .nav-link-top {
    z-index: 101;
  }
  .nav-link:hover {
    text-decoration: none !important;
    color: $color-primary !important;
  }
</style>
<style>
  nav ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  li {
    display: list-item;
    text-align: -webkit-match-parent;
  }
</style>





// WEBPACK FOOTER //
// src/components/layouts/MHeader.vue